import { render, staticRenderFns } from "./serviceAlert.vue?vue&type=template&id=69437fdc&scoped=true"
import script from "./serviceAlert.vue?vue&type=script&lang=js"
export * from "./serviceAlert.vue?vue&type=script&lang=js"
import style0 from "./serviceAlert.vue?vue&type=style&index=0&id=69437fdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69437fdc",
  null
  
)

export default component.exports